import { makeRequest } from '../../../lib/api';

const USER_PATH = '/v1/users';
const OFFICE_USER_PATH = '/v1/office_user';
const PARTNER_LEGAL_USER = '/v1/order_invoices/partner_legal_user'; // юр.лица пользователя
// const PARTNER_LEGAL_USER = '/v1/user_roles/users'; // юр.лица пользователя
const RECONCILIATION_PATH = '/v1/reconciliation_acts';
const REPORT_STATISTIC_PATH = '/v1/reports/clients/operator/statistics/personal';

class usersController {
  getUserList = (data = {}) => {
    return makeRequest('post', `${ USER_PATH }/find`, data);
  };

  getUser = (id) => {
    return makeRequest('get', `${ USER_PATH }/${ id }`);
  };

  getUsers = (partnerId) => {
    if (partnerId) {
      return makeRequest('get', `${ USER_PATH }?partnerId=${ partnerId }`);
    }
    return makeRequest('get', `${ USER_PATH }`);
  };

  // отправить Инвайт новому пользователю
  createUser = (data = {}) => {
    return makeRequest('post', `${ USER_PATH }`, data);
  };

  updateUser = (data = {}) => {
    return makeRequest('put', `${ USER_PATH }/${ data.id }`, data);
  };

  // повторная отправка инвайта пользователю
  deletePartnerAppLogin = (userId) => {
    return makeRequest('get', `${ USER_PATH }/partner/token/${ userId }`);
  };

  // повторная отправка инвайта пользователю
  reinviteUser = (data = {}) => {
    return makeRequest('post', `${ USER_PATH }/reinvite`, data);
  };

  getAvatar = (userId) => {
    return makeRequest('get', `${ USER_PATH }/${ userId }/avatar`, {}, {
      responseType: 'blob',
    });
  };

  setAvatar = (userId, file) => {
    const data = new FormData();

    data.append('image', file);

    return makeRequest('post', `${ USER_PATH }/${ userId }/avatar`, data);
  };

  // блок привязки пользователей к офисам партнёра
  getUserOffices = (userId) => {
    return makeRequest('get', `${ OFFICE_USER_PATH }/by_user?userId=${ userId }`);
  };

  createUserOffice = (data = {}) => {
    return makeRequest('post', `${ OFFICE_USER_PATH }`, data);
  };

  deleteUserOffice = (userOfficeId) => {
    return makeRequest('delete', `${ OFFICE_USER_PATH }/${ userOfficeId }`);
  };

  checkEmail = (data = {}) => {
    return makeRequest('post', '/v1/users/check_email', data);
  };

  // метод, возвращающий Промис с данными. Нужен для извлечения данных из хранилища в виде Промиса
  getLastCheckEmail = (data = {}) => {
    const promise = new Promise((resolve) => resolve(data));
    return promise;
  };

  // блок привязки пользователей к офисам партнёра
  getPartnerLegalUser = (userId) => {
    return makeRequest('get', `${ PARTNER_LEGAL_USER }?userId=${ userId }`);
  };

  createPartnerLegalUser = (data) => {
    return makeRequest('post', `${ PARTNER_LEGAL_USER }`, data);
  };

  deletePartnerLegalUser = (partnerLegalUserId) => {
    return makeRequest('delete', `${ PARTNER_LEGAL_USER }/${ partnerLegalUserId }`);
  };

  // блок взаиморасчётов
  getFirstUnpaidAct = (userId) => {
    return makeRequest('get', `${ RECONCILIATION_PATH }/first_unpaid?userId=${ userId }`);
  };

  getServiceFees = (userId) => {
    return makeRequest('get', `${ USER_PATH }/${ userId }/service_fees`);
  };

  getCurrentBalance = (userId) => {
    return makeRequest('get', `${ USER_PATH }/${ userId }/current_balance`);
  };

  getBalanceHistory = (userId) => {
    return makeRequest('get', `${ USER_PATH }/${ userId }/balance_history`);
  };

  getPersonalStatisticReport = (data = {}) => {
    return makeRequest('post', `${ REPORT_STATISTIC_PATH }`, data);
  };

  getStreamBalance = () => {
    return makeRequest('get', `${ USER_PATH }/stream_balances`);
  };

  getMaxChannels = () => {
    return makeRequest('get', `${ USER_PATH }/get_max_chats`);
  };

  getUserStates = () => {
    return makeRequest('get', `${ USER_PATH }/drivers_online`);
  };

  changeUserPassword = (request) => {
    return makeRequest('put', `${ USER_PATH }/${ request.id }/password`, { newPassword: request.newPassword });
  };

}

export default new usersController();
